import React, { useState, useEffect } from "react";
import CanvasJSReact from "../../../../assets/canvasjs.react";
import { Container, Title } from "./styles";
import { Row, Col } from "antd";
const toggleDataSeries = (e) => {
  if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
    e.dataSeries.visible = false;
  } else {
    e.dataSeries.visible = true;
  }
  e.chart.render();
};
function LotAverageWeightDash({ externalData }) {
  // Variables
  const { CanvasJSChart } = CanvasJSReact;
  const [data, setData] = useState(null);
  const chartOptions = {
    animationEnabled: true,
    zoomEnabled: true,
    height: 200,
    axisX: {
      valueFormatString: "MM/YY",
      interval: 1,
      intervalType: "month",
      crosshair: {
        enabled: true,
        snapToDataPoint: true,
      },
    },
    toolTip: {
      fontFamily: "Asap",
      shared: true,
    },
    axisY: {
      includeZero: true,
      suffix: " Kg",
      valueFormatString: "#",
      gridDashType: "dot",
    },
    axisY2: {
      title: "Capacidade de Utilização",
    },
    legend: {
      cursor: "pointer",
      itemclick: toggleDataSeries,
    },
    data: data,
  };

  // Effects
  useEffect(() => {
    setData(externalData);
  }, [externalData]);

  return (
    <Container>
      <Row type="flex">
        <Col span={24}>
          <Title>Peso MÉDIO</Title>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <CanvasJSChart options={chartOptions} />
        </Col>
      </Row>
    </Container>
  );
}

export default LotAverageWeightDash;
